import { useConcurso } from '../../../../../providers/ConcursoProvider';
import CargaActoAdministrativo from '../../CargaActoAdministrativo/CargaActoAdministrativo';
import CargaConvocatoria from '../../CargaConvocatoria';
import CargaDictamen from '../../CargaDictamen';

const TramitarLegales = () => {
  const concurso = useConcurso();
  const etapa = concurso.etapaLlamadoConcurso.idEtapaLlamadoConcurso;

  switch (etapa) {
    case 1:
      return <CargaConvocatoria concurso={concurso} />;
    case 4:
      return <CargaDictamen concurso={concurso} />;
    case 6:
      return <CargaActoAdministrativo />;
    default:
      return <div>No se reconoce el estado del concurso activo</div>;
  }
};
export default TramitarLegales;
